import React, { useState, Fragment } from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import {
  OrderDetails,
  Button,
  Checkbox,
  SidebarModal,
  Tooltip
} from "components"
import { moment, getOrderStatusTitle, getOrderStatusColor } from "utils"
import { deliveryTypeLabels } from "constant"
import classes from "./index.module.scss"

const OrderTableRow = props => {
  const {
    order,
    setOrders,
    isSelected,
    showCheckbox,
    setSelectedOrders
  } = props

  const [t, i18n] = useTranslation()

  const serviceTypeName =
    useSelector(state =>
      state.systemSettings.serviceTypeName
    )

  const [openOrderDetailsSidebar, setOpenOrderDetailsSidebar] = useState(false)

  const handleSelectOrder = checked => {
    setSelectedOrders(prev => {
      const object = { ...prev }

      if (checked) {
        object[order._id] = { ...order }
      } else {
        delete object[order._id]
      }

      return object
    })
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  const dailyOrderNumber =
    order.dailyOrderNumber !== undefined
      ? String(order.dailyOrderNumber).padStart(3, "0")
      : null

  return (
    <Fragment>
      <tr
        onClick={() => setOpenOrderDetailsSidebar(true)}
        className={classes["item"]}
      >
        <td
          onClick={e => e.stopPropagation()}
          className={clsx(
            classes["checkbox"],
            isLtr && classes["checkbox-ltr"]
          )}
        >
          {
            showCheckbox &&
            <Checkbox
              checked={isSelected}
              onChange={handleSelectOrder}
            />
          }
        </td>

        <td className={classes["text"]}>
          <span>
            {order.code}
            {dailyOrderNumber && ` (${dailyOrderNumber})`}
          </span>
          {
            !order.isViewed &&
            <span
              className={clsx(
                classes["new-badge"],
                isLtr && classes["new-badge-ltr"]
              )}
            >
              {t("جدید")}
            </span>
          }
        </td>

        <td className={clsx(classes["text"], classes["center"])}>
          <span
            className={classes["tag"]}
            style={{
              backgroundColor: getOrderStatusColor(order)
            }}
          >
            {t(getOrderStatusTitle(order))}
          </span>
        </td>

        <td className={classes["text"]}>
          <div>
            {moment(order.date).format("jYYYY/jM/jD")}
          </div>
          <div>
            {moment(order.date).format("HH:mm")}
          </div>
        </td>

        <td className={classes["text"]}>
          {t(deliveryTypeLabels[order["deliveryType"]])}
        </td>

        <td>
          {order.addedBySystem ? order.addedByFullName : t("سایت")}
        </td>

        <td className={classes["text"]}>
          <Tooltip title={order.branchName}>
            <div className={classes["branch"]}>
              {order.branchName}
            </div>
          </Tooltip>
        </td>

        {
          serviceTypeName === "restaurant" &&
          <Fragment>
            <td className={classes["text"]}>
              {order.tableNumber}
            </td>

            <td className={classes["text"]}>
              {order.cinemaSolonNumber || ""}
            </td>
          </Fragment>
        }

        <td className={clsx(classes["text"], classes["center"])}>
          <Button
            onClick={() => setOpenOrderDetailsSidebar(true)}
          >
            {t("مشاهده")}
          </Button>
        </td>
      </tr>

      <SidebarModal
        urlQuery="code"
        urlQueryValue={order.code}
        title={`${t("سفارش")} ${order.code}${
          dailyOrderNumber
            ? ` - ${t("شماره_روزانه")} ${dailyOrderNumber}`
            : ""
        }`}
        open={openOrderDetailsSidebar}
        onClose={() => setOpenOrderDetailsSidebar(false)}
      >
        <OrderDetails
          order={order}
          setOrders={setOrders}
          setOpenOrderDetailsSidebar={setOpenOrderDetailsSidebar}
        />
      </SidebarModal>
    </Fragment>
  )
}

export default React.memo(OrderTableRow)
